export default {
	// === HÓA ĐƠN GTGT NĐ70 - 97 TRƯỜNG ===
	formatXML_GTGT_ND70: [
		// === THÔNG TIN CHUNG - TTChung (17 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'Phiên bản của thông điệp',
			TagName: 'PBan',
			TagNameCheck: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			TagNameCheck: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			TagNameCheck: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			TagNameCheck: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			TagNameCheck: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã hồ sơ',
			TagName: 'MHSo',
			TagNameCheck: 'MHSo',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp là hoá đơn đề nghị cấp mã của Cơ quan thuế theo từng lần phát sinh)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			TagNameCheck: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Số bảng kê (Số của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'SBKe',
			TagNameCheck: 'SBKe',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Ngày bảng kê (Ngày của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'NBKe',
			TagNameCheck: 'NBKe',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			TagNameCheck: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I, Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			TagNameCheck: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			TagNameCheck: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'MST tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			TagNameCheck: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'MST đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			TagNameCheck: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			TagNameCheck: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			TagNameCheck: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},

		// === THÔNG TIN HĐ LIÊN QUAN - TTHDLQuan (10 trường) ===
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			TagNameCheck: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số',
			Constraint:
				'Bắt buộc (1: Thay thế, 2: Điều chỉnh, 3: Thay thế nhiều HĐ, 4: Điều chỉnh nhiều HĐ, 5: Chiết khấu thương mại)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			TagNameCheck: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo  Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			TagNameCheck: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			TagNameCheck: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			TagNameCheck: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ngày lập hoá đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			TagNameCheck: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số bảng kê có liên quan (Số bảng kê thay thế/điều chỉnh)',
			TagName: 'SBKCLQuan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho nhiều hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày bảng kê có liên quan (Ngày lập bảng kê thay thế/điều chỉnh)',
			TagName: 'NBKCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho nhiều hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		// === THÔNG TIN NGƯỜI BÁN - NBan (11 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			TagNameCheck: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			TagNameCheck: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			TagNameCheck: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã cửa hàng',
			TagName: 'MCHang',
			TagNameCheck: 'MCHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên cửa hàng',
			TagName: 'TCHang',
			TagNameCheck: 'TCHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			TagNameCheck: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			TagNameCheck: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			TagNameCheck: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			TagNameCheck: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			TagNameCheck: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			TagNameCheck: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},

		// === THÔNG TIN NGƯỜI MUA - NMua (12 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			TagNameCheck: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			TagNameCheck: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			TagNameCheck: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			TagNameCheck: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			TagNameCheck: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			TagNameCheck: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân (Số CC/CCCD/số định danh)',
			TagName: 'CCCDan',
			TagNameCheck: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu (Số hộ chiếu/Giấy tờ nhập xuất cảnh)',
			TagName: 'SHChieu',
			TagNameCheck: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			TagNameCheck: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			TagNameCheck: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			TagNameCheck: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			TagNameCheck: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},

		// === CHI TIẾT HHDV - HHDVu (15 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			TagNameCheck: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			TagNameCheck: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			TagNameCheck: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			TagNameCheck: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			TagNameCheck: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			TagNameCheck: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			TagNameCheck: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			TagNameCheck: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			TagNameCheck: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			TagNameCheck: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			TagNameCheck: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục V  Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},

		// === THÔNG TIN HÀNG HÓA ĐẶC TRƯNG - TTHHDTrung (3 trường mới ND70) ===
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)',
			IsTitle: true
		},
		{
			TargetName: 'Loại hàng hóa đặc trưng',
			TagName: 'LHHDTrung',
			TagNameCheck: 'LHHDTrung',
			MaxLength: 1,
			DataType: 'Số (Chi tiết Phụ lục XV, Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
		},
		{
			TargetName: 'Tên trường',
			TagName: 'TTruong',
			TagNameCheck: 'TTruong',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự (Chi tiết Cột “Giá trị bắt buộc” tại Phụ lục XV Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
		},
		{
			TargetName: 'Dữ liệu',
			TagName: 'DLieu',
			TagNameCheck: 'DLieu',
			MaxLength: 200,
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
		},

		// === THÔNG TIN THUẾ SUẤT - LTSuat (3 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			TagNameCheck: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục V Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			TagNameCheck: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			TagNameCheck: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},

		// === THÔNG TIN THANH TOÁN - TToan (8 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			TagNameCheck: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ không chịu thuế',
			TagName: 'TGTKCThue',
			TagNameCheck: 'TGTKCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			TagNameCheck: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
			IsTitle: true
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			TagNameCheck: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			TagNameCheck: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			TagNameCheck: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			TagNameCheck: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			TagNameCheck: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			TagNameCheck: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},

		// === QR CODE VÀ CHỮ KÝ SỐ (4 trường) ===
		{
			TargetName: 'HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true
		},
		{
			TargetName: 'Dữ liệu QR Code (Chi tiết tại Khoản 7, Mục IV, Phần I, Quyết định số này)',
			TagName: '',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: '',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			TagNameCheck: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: '',
			IsTitle: false,
			PathRoot: 'HDon'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			TagNameCheck: 'Signature',
			DataType: '',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			TagNameCheck: 'Signature',
			DataType: '',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\ĐLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			TagNameCheck: 'Signature',
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DSCKS\\CQT'
		}
	],

	// === Hóa đơn GTGT MÁY TÍNH TIỀN NDD70 ===
	formatXML_GTGT_MTT_ND70: [
		// === THÔNG TIN CHUNG - TTChung (17 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'Phiên bản của thông điệp',
			TagName: 'PBan',
			TagNameCheck: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			TagNameCheck: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			TagNameCheck: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			TagNameCheck: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			TagNameCheck: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			TagNameCheck: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Số bảng kê (Số của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'SBKe',
			TagNameCheck: 'SBKe',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Ngày bảng kê (Ngày của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'NBKe',
			TagNameCheck: 'NBKe',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			TagNameCheck: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung'
		},
		// === THÔNG TIN HĐ LIÊN QUAN - TTHDLQuan (10 trường) ===
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hóa đơn điều chỉnh hoặc thay thế',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			TagNameCheck: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh; 5 Chiết khấu thương mại)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			TagNameCheck: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			TagNameCheck: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			TagNameCheck: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			TagNameCheck: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		{
			TargetName: 'Ngày lập hoá đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			TagNameCheck: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
		},
		// === THÔNG TIN NGƯỜI BÁN - NBan (11 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Tên đơn vị bán hàng',
			TagName: 'Ten',
			TagNameCheck: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			TagNameCheck: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			TagNameCheck: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã cửa hàng',
			TagName: 'MCHang',
			TagNameCheck: 'MCHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên cửa hàng',
			TagName: 'TCHang',
			TagNameCheck: 'TCHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			TagNameCheck: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			TagNameCheck: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			TagNameCheck: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		// === THÔNG TIN NGƯỜI MUA - NMua (12 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			TagNameCheck: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên (Tên đơn vị mua hàng)',
			TagName: 'Ten',
			TagNameCheck: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			TagNameCheck: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách',
			TagName: 'MDVQHNSach',
			TagNameCheck: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			TagNameCheck: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			TagNameCheck: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân (Số CC/CCCD/số định danh)',
			TagName: 'CCCDan',
			TagNameCheck: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu (Số hộ chiếu/Giấy tờ nhập xuất cảnh)',
			TagName: 'SHChieu',
			TagNameCheck: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
		},
		// === CHI TIẾT HHDV - HHDVu (15 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			TagNameCheck: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			TagNameCheck: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			TagNameCheck: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			TagNameCheck: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			TagNameCheck: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			TagNameCheck: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			TagNameCheck: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			TagNameCheck: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			TagNameCheck: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			TagNameCheck: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			TagNameCheck: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục V kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},

		// === THÔNG TIN HÀNG HÓA ĐẶC TRƯNG - TTHHDTrung (3 trường mới ND70) ===
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)',
			IsTitle: true
		},
		{
			TargetName: 'Loại hàng hóa đặc trưng',
			TagName: 'LHHDTrung',
			TagNameCheck: 'LHHDTrung',
			MaxLength: 1,
			DataType: 'Số (Chi tiết Phụ lục XV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
		},
		{
			TargetName: 'Tên trường',
			TagName: 'TTruong',
			TagNameCheck: 'TTruong',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự (Chi tiết Cột “Giá trị bắt buộc” tại Phụ lục XV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
		},
		{
			TargetName: 'Dữ liệu',
			TagName: 'DLieu',
			TagNameCheck: 'DLieu',
			MaxLength: 200,
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
		},

		// === THÔNG TIN THUẾ SUẤT - LTSuat (3 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			TagNameCheck: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục V kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Thành tiền (Tổng Thành tiền chưa có thuế GTGT theo từng loại thuế suất)',
			TagName: 'ThTien',
			TagNameCheck: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			TagNameCheck: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},

		// === THÔNG TIN THANH TOÁN - TToan (8 trường) ===
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			TagNameCheck: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			TagNameCheck: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			TagNameCheck: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			TagNameCheck: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			TagNameCheck: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},

		// === QR CODE VÀ CHỮ KÝ SỐ (4 trường) ===
		{
			TargetName: 'HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true
		},
		{
			TargetName: 'Dữ liệu QR Code',
			TagName: '',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode'
		},
		{
			TargetName: 'Thẻ HDon\\MCCQT',
			IsTitle: true
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			TagNameCheck: 'MCCQT',
			MaxLength: 23,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\MCCQT'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			TagNameCheck: 'Signature',
			DataType: '',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			TagNameCheck: 'Signature',
			DataType: '',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DSCKS\\NMua'
		}
	],

	// Bán hàng NĐ 70
	formatXML_BanHang_ND70: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản của thông điệp',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã hồ sơ',
			TagName: 'MHSo',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp là hoá đơn đề nghị cấp mã của Cơ quan thuế theo từng lần phát sinh )',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Hoá đơn dành cho khu phi thuế quan (Hóa đơn dành cho tổ chức, cá nhân trong khu phi thuế quan)',
			TagName: 'HDDCKPTQuan',
			MaxLength: 1,
			DataType:
				'Số (1: Hóa đơn dành cho tổ chức, cá nhân trong khu phi thuế quan, 0: Hóa đơn không dành cho tổ chức, cá nhân trong khu phi thuế quan)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Số bảng kê (Số của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'SBKe',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Ngày bảng kê (Ngày của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'NBKe',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType:
				'Số (1: Thay thế, 2: Điều chỉnh, 3: Thay thế nhiều hóa đơn, 4: Điều chỉnh nhiều hóa đơn, 5: Chiết khấu thương mại)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hoá đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số bảng kê có liên quan (Số bảng kê thay thế/điều chỉnh)',
			TagName: 'SBKCLQuan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho nhiều hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày bảng kê có liên quan (Ngày lập bảng kê thay thế/điều chỉnh)',
			TagName: 'NBKCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho nhiều hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã địa điểm kinh doanh',
			TagName: 'MDDKDoanh',
			TagNameCheck: 'MDDKDoanh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu là HKD, CNKD)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên địa điểm kinh doanh',
			TagName: 'TDDKDoanh',
			TagNameCheck: 'TDDKDoanh',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu là HKD, CNKD)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ địa điểm kinh doanh',
			TagName: 'DCDDKDoanh',
			TagNameCheck: 'DCDDKDoanh',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu là HKD, CNKD)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã cửa hàng',
			TagName: 'MCHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên cửa hàng',
			TagName: 'TCHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách (Mã số đơn vị có quan hệ với ngân sách)',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân (Số CC/CCCD/số định danh)',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu (Số hộ chiếu/Giấy tờ nhập xuất cảnh)',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thành tiền',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)',
			IsTitle: true
		},
		{
			TargetName: 'Loại hàng hóa đặc trưng',
			TagName: 'LHHDTrung',
			MaxLength: 1,
			DataType: 'Số (Chi tiết Phụ lục XV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Tên trường',
			TagName: 'TTruong',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự (Chi tiết Cột “Giá trị bắt buộc” tại Phụ lục XV Quy định này)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Dữ liệu',
			TagName: 'DLieu',
			MaxLength: 200,
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
			IsTitle: true
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true
		},
		{
			TargetName: 'Dữ liệu QR Code',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\DLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\DLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)'
		}
	],

	// == Hóa đơn bán hàng MTT 70 ==
	formatXML_BH_MTT_ND70: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản của thông điệp',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Số bảng kê (Số của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'SBKe',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Ngày bảng kê (Ngày của bảng kê các loại hàng hóa, dịch vụ đã bán kèm theo hóa đơn hoặc hóa đơn chiết khấu thương mại)',
			TagName: 'NBKe',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh, 5: Chiết khấu thương mại)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hoá đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Tên đơn vị bán hàng',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã địa điểm kinh doanh',
			TagName: 'MDDKDoanh',
			TagNameCheck: 'MDDKDoanh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu là HKD, CNKD)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên địa điểm kinh doanh',
			TagName: 'TDDKDoanh',
			TagNameCheck: 'TDDKDoanh',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu là HKD, CNKD)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ địa điểm kinh doanh',
			TagName: 'DCDDKDoanh',
			TagNameCheck: 'DCDDKDoanh',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (nếu là HKD, CNKD)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã cửa hàng',
			TagName: 'MCHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên cửa hàng',
			TagName: 'TCHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},

		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách (Mã số đơn vị có quan hệ với ngân sách)',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân (Số CC/CCCD/số định danh)',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu (Số hộ chiếu/Giấy tờ nhập xuất cảnh)',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Thành tiền',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)',
			IsTitle: true
		},
		{
			TargetName: 'Loại hàng hóa đặc trưng',
			TagName: 'LHHDTrung',
			MaxLength: 1,
			DataType: 'Số (Chi tiết Phụ lục XV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Tên trường',
			TagName: 'TTruong',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự (Chi tiết Cột “Giá trị bắt buộc” tại Phụ lục XV Quy định này)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Dữ liệu',
			TagName: 'DLieu',
			MaxLength: 200,
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code',
			IsTitle: true
		},
		{
			TargetName: 'Dữ liệu QR Code',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode chứa dữ liệu QR Code'
		},
		{
			TargetName: 'Thẻ HDon\\MCCQT',
			IsTitle: true
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			TagNameCheck: 'MCCQT',
			MaxLength: 23,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\MCCQT'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NMua'
		}
	],

	// == Vé GTGT 70 ==
	formatXML_GTGT_Ticket_ND70: [
		{
			TargetName: 'Thẻ HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'Phiên bản của thông điệp',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên hóa đơn',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ký hiệu hóa đơn',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Số hóa đơn',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Ngày lập',
			TagName: 'NLap',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Đơn vị tiền tệ',
			TagName: 'DVTTe',
			TagNameCheck: 'DVTTe',
			MaxLength: 3,
			DataType: 'Chuỗi ký tự (Chi tiết tại Khoản 2, Mục IV, Phần I kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tỷ giá',
			TagName: 'TGia',
			TagNameCheck: 'TGia',
			MaxLength: '7,2',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp Đơn vị tiền tệ là VND)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Hình thức thanh toán',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử',
			TagName: 'MSTTCGP',
			TagNameCheck: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'MSTDVNUNLHDon',
			TagNameCheck: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Tên đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Đối với trường hợp ủy nhiệm lập hóa đơn)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất hóa đơn',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Số (1: Thay thế, 2: Điều chỉnh)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Loại hóa đơn có liên quan (Loại hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục VI kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu mẫu số hóa đơn có liên quan (Ký hiệu mẫu số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục II kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ký hiệu hóa đơn có liên quan (Ký hiệu hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Số hóa đơn có liên quan (Số hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'Chuỗi ký tự',
			Constraint:
				'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn có Ký hiệu mẫu số hóa đơn, Ký hiệu hóa đơn, Số hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ngày lập hoá đơn có liên quan (Ngày lập hóa đơn bị thay thế/điều chỉnh)',
			TagName: 'NLHDCLQuan',
			DataType: 'Ngày',
			Constraint: 'Bắt buộc (Đối với trường hợp điều chỉnh, thay thế cho 1 hóa đơn)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Ghi chú',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\TTChung\\TTHDLQuan chứa thông tin hóa đơn liên quan trong trường hợp là hoá đơn điều chỉnh hoặc thay thế'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Tên đơn vị bán hàng',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Mã cửa hàng',
			TagName: 'MCHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên cửa hàng',
			TagName: 'TCHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			TagNameCheck: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			TagNameCheck: 'Fax',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			TagNameCheck: 'Website',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Tên',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã số thuế',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã đơn vị quan hệ ngân sách (Mã số đơn vị có quan hệ với ngân sách)',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Mã khách hàng',
			TagName: 'MKHang',
			TagNameCheck: 'MKHang',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số điện thoại',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Căn cước công dân (Số CC/CCCD/số định danh)',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số hộ chiếu (Số hộ chiếu/Giấy tờ nhập xuất cảnh)',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Địa chỉ thư điện tử',
			TagName: 'DCTDTu',
			TagNameCheck: 'DCTDTu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Họ và tên người mua hàng',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Số tài khoản ngân hàng',
			TagName: 'STKNHang',
			TagNameCheck: 'STKNHang',
			MaxLength: 30,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tên ngân hàng',
			TagName: 'TNHang',
			TagNameCheck: 'TNHang',
			MaxLength: 400,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Tính chất',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Số (Chi tiết tại Phụ lục IV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số thứ tự',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Mã hàng hóa, dịch vụ',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tên hàng hóa, dịch vụ',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn vị tính',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Số lượng',
			TagName: 'SLuong',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Đơn giá',
			TagName: 'DGia',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tỷ lệ % chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'TLCKhau',
			MaxLength: '6,4',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Số tiền chiết khấu (Trong trường hợp thể hiện thông tin chiết khấu cho từng hàng hóa, dịch vụ)',
			TagName: 'STCKhau',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thành tiền (thành tiền chưa có thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, thành tiền đối với hóa đơn khác thuộc loại hóa đơn bán hàng)',
			TagName: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Trừ trường hợp TChat có giá trị là “4-Ghi chú/diễn giải”)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thuế suất (Thuế suất thuế GTGT đối với hóa đơn khác thuộc loại hóa đơn GTGT, đối với hóa đơn khác thuộc loại hóa đơn bán hàng không có thẻ này)',
			TagName: 'TSuat',
			TagNameCheck: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục V kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)',
			IsTitle: true
		},
		{
			TargetName: 'Loại hàng hóa đặc trưng',
			TagName: 'LHHDTrung',
			MaxLength: 1,
			DataType: 'Số (Chi tiết Phụ lục XV kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Tên trường',
			TagName: 'TTruong',
			MaxLength: 20,
			DataType: 'Chuỗi ký tự (Chi tiết Cột “Giá trị bắt buộc” tại Phụ lục XV Quy định này)',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Dữ liệu',
			TagName: 'DLieu',
			MaxLength: 200,
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot:
				'Thẻ HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung chứa danh sách thông tin hàng hóa đặc trưng (bắt buộc nếu thẻ TChat có giá trị là “5”)'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true
		},
		{
			TargetName: 'Thuế suất (Thuế suất thuế GTGT)',
			TagName: 'TSuat',
			TagNameCheck: 'TSuat',
			MaxLength: 11,
			DataType: 'Chuỗi ký tự (Chi tiết tại Phụ lục V kèm theo Quyết định số 1306/QĐ-CT)',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Thành tiền (Thành tiền chưa có thuế GTGT)',
			TagName: 'ThTien',
			TagNameCheck: 'ThTien',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tiền thuế (Tiền thuế GTGT)',
			TagName: 'TThue',
			TagNameCheck: 'TThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName:
				'Thẻ HDon\\DLHDon\\NDHDon\\TToan (hóa đơn khác thuộc loại hóa đơn bán hàng thì không có thẻ này)',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chưa thuế (Tổng cộng thành tiền chưa có thuế GTGT)',
			TagName: 'TgTCThue',
			TagNameCheck: 'TgTCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ không chịu thuế',
			TagName: 'TGTKCThue',
			TagNameCheck: 'TGTKCThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thuế (Tổng cộng tiền thuế GTGT)',
			TagName: 'TgTThue',
			TagNameCheck: 'TgTThue',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
			IsTitle: true
		},
		{
			TargetName: 'Tên loại phí',
			TagName: 'TLPhi',
			TagNameCheck: 'TLPhi',
			MaxLength: 100,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Tiền phí',
			TagName: 'TPhi',
			TagNameCheck: 'TPhi',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Các chỉ tiêu sau được đặt bên trong thẻ HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Tổng tiền chiết khấu thương mại',
			TagName: 'TTCKTMai',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng giảm trừ khác',
			TagName: 'TGTKhac',
			TagNameCheck: 'TGTKhac',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng số',
			TagName: 'TgTTTBSo',
			MaxLength: '21,6',
			DataType: 'Số',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tổng tiền thanh toán bằng chữ',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Thẻ HDon\\DLQRCode',
			IsTitle: true
		},
		{
			TargetName: 'Dữ liệu QR Code',
			MaxLength: 512,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DLQRCode'
		},
		{
			TargetName:
				'Với hóa đơn điện tử có mã, nếu đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về chỉ tiêu Mã của cơ quan thuế trên hóa đơn điện tử (Thẻ MCCQT, đặt bên trong thẻ HDon)',
			IsTitle: true
		},
		{
			TargetName: 'Mã của cơ quan thuế',
			TagName: 'MCCQT',
			TagNameCheck: 'MCCQT',
			MaxLength: 34,
			DataType: 'Chuỗi ký tự',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người bán',
			TagName: 'Signature',
			Constraint: 'Bắt buộc (Nếu có)',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Thẻ HDon\\DSCKS\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số người mua',
			TagName: 'Signature',
			Constraint: 'Không bắt buộc',
			IsTitle: false,
			PathRoot: 'Thẻ HDon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'Với hóa đơn điện tử đủ điều kiện cấp mã, hệ thống của Cơ quan thuế trả về hóa đơn điện tử và bổ sung thẻ CQT (đặt bên trong thẻ HDon\\DSCKS) chứa thông tin chữ ký số của Cơ quan thuế (ký trên thẻ HDon\\ĐLHDon, thẻ HDon\\MCCQT và thẻ HDon\\DSCKS\\CQT\\Signature\\Object)',
			IsTitle: true
		},
		{
			TargetName: 'Chữ ký số cơ quan thuế',
			TagName: 'Signature',
			TagNameCheck: 'Signature',
			DataType: '',
			Constraint: 'Bắt buộc',
			IsTitle: false,
			PathRoot: 'HDon\\DSCKS\\CQT'
		}
	]
};
